module.exports = __webpack_public_path__ + "static/clutch-b2b-award-c63674ad6069834edcf459687df4b96e.png";